import { z } from 'zod';
import { requireFields, yesNoRequired } from '@utils/form-schema';

export const assessDiabetesSchema = z
    .object({
        hasDiabetes: yesNoRequired,
        diabetesStatus: z.string(),
    })
    .superRefine((data, ctx) => {
        if (data.hasDiabetes === '1') {
            requireFields(ctx, data, 'diabetesStatus');
        }
    });
